import { Box, Typography, useTheme } from '@mui/material';

import { FC } from 'react';

import { pxToRem } from '@/theme/typography';
import ImageBoxFuture from '../shared/image-box-future';

interface CastNameWithImgProps {
  img?: string | File;
  name?: string;
}

export const CastNameWithImg: FC<CastNameWithImgProps> = castNameWithImgProps => {
  const theme = useTheme();
  return (
    <Box
      component='div'
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'column',
        mr: pxToRem(16),
        width: '104px',
        alignItems: 'center',
      }}
    >
      <ImageBoxFuture
        img={castNameWithImgProps?.img}
        title={castNameWithImgProps?.name}
        objectFit='cover'
        sx={{
          borderRadius: '15px',
          width: '90px',
          height: '92px',
          overflow: 'hidden',
          pt: castNameWithImgProps.img ? '0' : '10px',
          background: '#eaecef',
        }}
      />

      <Typography
        component='p'
        sx={{
          fontSize: pxToRem(18),
          color: theme.palette.grey[50],
          textAlign: 'center',
          my: pxToRem(8),
          overflowWrap: 'anywhere',
        }}
      >
        {castNameWithImgProps.name}
      </Typography>
    </Box>
  );
};

export default CastNameWithImg;
